import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=710685fa&scoped=true&"
import script from "./AlbumDetail.vue?vue&type=script&lang=js&"
export * from "./AlbumDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710685fa",
  null
  
)

export default component.exports